import createUpload from '@ai/mss-upload-js/src/index'
import { currentInitConfig } from "@/utils/init"
function getFileSize(file, unit = 'KB') {
  const fileSize = (file && file.size) || 0;
  return unit === 'MB' ? parseInt(fileSize * 100 / (1024 * 1024), 10) / 100 : parseInt(fileSize * 100 / 1024, 10) / 100;
}

function initUploadInstance(opts, mode = 0) {
  // 0: 自动选择，根据文件大小选择；1：普通上传  2：分片上传，需要和加签方法一一对应
  let signatureUrl = '/mtd-api/assets-internal/v2/upload/multiUploadSign';
  const defaultSliceSize = 1024 * 1024 * 50;
  if (mode === 0) {
    const file = opts.file;
    const sliceSize = opts.sliceSize || defaultSliceSize;
    mode = 2;
    if (file) {
      if (file.size <= sliceSize) {
        mode = 1;
        signatureUrl = '/mtd-api/assets-internal/v2/upload/getUploadSign';
      }
    }
  }
  const { s3Config } = currentInitConfig();
  return createUpload(Object.assign({

  }, {
    signatureUrl: signatureUrl,   //加签接口url
    prefix_type: "s3_style",        // 迁移服务密钥
    bucket: s3Config.bucket,                                        //桶
    hashMode: true,																									//		Boolean,选传，标示上传后的文件名是否有唯一性，默认为 false：使用传入的key或原始文件名；true: 使用当前时间戳加签生成的字符串做文件名
    sliceSize: defaultSliceSize,
      s3_host: s3Config.endpoint,
    isHttps: true,
    validateFile(file) {                                          //验证选择的文件是否符合预期，return true则继续，return false则中止后续流程
      return true
    },
    onProgress: (percent) => {
      //上传进度回调
    },
    onStart: function () {
    },                                         //上传开始回调
    onSuccess: (fileUrl) => {

    },
    onError(errorMsg) {
      console.error(errorMsg)                                         //上传失败回调
    }
  }, opts), mode);
}

function getFileExtension(file) {
  const mimeMap = {
    'image/jpg': 'jpg',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/tif': 'tiff',
    'image/tiff': 'tiff',
    'image/vnd.adobe.photoshop': 'psd',
    'application/pdf': 'pdf',
    'application/postscript': 'eps',
  }
  const mimeType = file.type;
  const ext = file.name.split('.') || [];
  const extension = ext[ext.length - 1];

  return mimeType ? mimeMap[mimeType] : (extension || 'unknown');
}

async function getImageInfo(imageFile) {
  return (new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(imageFile);
    reader.onload = (e) => {
      // 普通img资源文件
      const image = new Image();
      image.onload = (image) => {
        const {
          src: base64Str,
          width,
          height
        } = image.target;
        const orientation = (width >= height) ? (width === height ? 3 : 1) : 2; // 1-横图，2-竖图，3-方图
        resolve({
          base64Str,
          width,
          height,
          orientation,
        });
      }
      image.src = e.target.result;
    };
  })).catch(() => ({

  }));
}

// async function getImageDetail(file) {
//   return (new Promise((resolve) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = (e) => {
//       const result = e.target.result;
//       const { fileExtension, pureImageFileFlag } = getFileExtension(e.target.result);
//       if (pureImageFileFlag) {
//         // 普通img资源文件
//         const image = new Image();
//         image.onload = (image) => {
//           const {
//             src: base64Str,
//             width,
//             height
//           } = image.target;
//           const orientation = (width >= height) ? (width === height ? 3 : 1) : 2; // 1-横图，2-竖图，3-方图
//           resolve({
//             base64Str,
//             width,
//             height,
//             orientation,
//             isImageLikeFile: false,
//             fileExtension,
//           });
//         }
//         image.src = e.target.result;
//       } else {
//         // 类img的资源文件
//         const base64Str = result;
//         resolve({
//           base64Str,
//           isImageLikeFile: true,
//           fileExtension,
//         });
//         return;
//       }
//     };
//   })).catch(() => ({}));
// }


// 上传venus
function initVenusUploadInstance(opts) {
  const { venusConfig } = currentInitConfig();
  const uploadOptions = {
    signatureUrl: `/mtd-api/assets-internal/v2/upload/getBAToken`,
    bucket: venusConfig.bucket,
    authType: 'BAToken',
    clientId: venusConfig.client_id,
    isTest: venusConfig.isTest,
    isHttps: true,
    multiple: true,
    networkEnv: 'public',
    accept: ['.png', '.jpeg', '.jpg', '.gif', '.webp'],
    queryParams: { isHttps: true },
    onProgress(percent) { },
    validateFile(file) {
      return true
    },
    onStart() {
      console.time('uploadFile')
    },
    onFinish(fileInfos) {
    },
    onError(err) {
      console.log('err is ->', err);
    }
  }
  const options = Object.assign(uploadOptions, opts);
  return createUpload(options, 'venus');
}

export default {
  getFileSize,
  getImageInfo,
  getFileExtension,
  initUploadInstance,
  initVenusUploadInstance
};

